import { _ } from '@ngx-translate/core';

export type FileSizeType = 'B' | 'KB' | 'MB' | 'GB';

export const FILE_SIZE: Record<FileSizeType, string> = {
  B: _('common.constants.fileSize.b'),
  KB: _('common.constants.fileSize.kb'),
  MB: _('common.constants.fileSize.mb'),
  GB: _('common.constants.fileSize.gb'),
} as const;
